import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Item, Empty } from '.'
import AccountStatementPlaceholder from './AccountStatementPlaceholder'

class Expirations extends Component {
  buildItem = ({ expirationDate, value }, index) => {
    const date = moment.utc(expirationDate).format('DD/MM/YYYY - HH:mm')
    return (
      <Item
        key={index}
        description={this.props.campaign.name}
        subtitle={`Expira em ${date}`}
        value={value}
        currency={this.props.currency}
        cssColor='color-brand-1'
        icon='warning'
      />
    )
  }

  list = () => {
    const { items } = this.props.creditToExpire
    if (!items || items.length < 1) return <Empty />

    return items.map(this.buildItem)
  }

  render () {
    const { isLoading } = this.props.creditToExpire
    if (isLoading) {
      return <AccountStatementPlaceholder />
    }

    return (
      <div className='item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'>
        {this.list()}
      </div>
    )
  }
}

Expirations.propTypes = {
  creditToExpire: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  campaign: {
    name: PropTypes.string.isRequired
  }
}

export default Expirations



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/Expirations.js